import React from "react";
import { http, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Link2, Copy, ExternalLink } from "lucide-react";

// F1.5-H: copy/open the customer's link (digital nota or order/debt page).
// The owner may issue a new link or revoke it (the old one stops working).
export default function LinkPublik({ kind, id, label, testid }) {
  const { user } = useAuth();
  const isOwner = user?.role === "admin";
  const base = kind === "nota" ? `/notas/${id}/link` : `/customers/${id}/link`;
  const [link, setLink] = React.useState(null);
  const [msg, setMsg] = React.useState(null);
  const ambil = async () => {
    setMsg(null);
    try { const r = (await http.get(base)).data; setLink(r.url); return r.url; }
    catch (e) { setMsg(formatApiErrorDetail(e.response?.data?.detail) || e.message); return null; }
  };
  const salin = async () => {
    const url = link || (await ambil());
    if (!url) return;
    try { await navigator.clipboard.writeText(url); setMsg("Link disalin"); } catch { setMsg(url); }
  };
  const owner = async (aksi) => {
    if (aksi === "cabut" && !window.confirm("Cabut link? Link lama langsung tidak bisa dibuka.")) return;
    try { const r = (await http.post(`${base}/${aksi}`)).data; setLink(r.url); setMsg(aksi === "cabut" ? "Link dicabut" : "Link baru dibuat"); }
    catch (e) { setMsg(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };
  return (
    <span data-testid={testid} className="inline-flex flex-wrap items-center gap-1.5 text-xs">
      <button data-testid={`${testid}-salin`} onClick={salin} className="inline-flex items-center gap-1 rounded border border-slate-600 px-2 py-1 text-slate-200 hover:border-amber-500/50"><Copy size={12} /> {label}</button>
      {link && <a href={link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-cyan-300"><ExternalLink size={12} /> buka</a>}
      {isOwner && <>
        <button onClick={() => owner("ganti")} className="inline-flex items-center gap-1 text-slate-400 hover:text-amber-300"><Link2 size={12} /> link baru</button>
        <button onClick={() => owner("cabut")} className="text-slate-400 hover:text-red-300">cabut</button></>}
      {msg && <span className="text-slate-400">{msg}</span>}
    </span>
  );
}
